interface ProductDefinition {
    id: string;
    label: string;
    image: string;
    disabled?: boolean;
}

export const PRODUCT_TYPE_CATEGORIES: { name: string, types: ProductDefinition[], disabled?: boolean }[] = [
    {
        name: "Wrappers",
        types: [{
            id: "auto-wrappers",
            label: "Weigh-Wrap-Labelers",
            image: "assets/product-groups/weigh-wrap-labelers.webp"

        }, {
            id: "weigh-seal-labelers",
            label: "Weigh-Seal-Labelers",
            image: "assets/product-groups/weigh-seal-labelers.webp"
        }, {
            id: "banding-systems",
            label: "Banding Systems",
            image: "assets/product-groups/banding-systems.webp"
        }, {
            id: "handwrap-station",
            label: "Hand Wrapping Stations",
            image: "assets/product-groups/hand-wrapping-stations.webp"
        },]
    },
    {
        name: "Scales",
        types: [{
            id: "pc-scales",
            label: "PC-Based Scales",
            image: "assets/product-groups/pc-based-scales.webp",

        }, {
            id: "digital-scales",
            label: "Digital Scales",
            image: "assets/product-groups/digital-scales.webp",

        }, {
            id: "non-pc-scales",
            label: "Service Counter Scales",
            image: "assets/product-groups/service-counter-scales.webp",

        }, {
            id: "self-service-scales",
            label: "Self-Service Scales",
            image: "assets/product-groups/self-service-scales.webp"

        },
        {
            id: "manual-weigh-labelers",
            label: "Manual Weighing Labelers",
            image: "assets/product-groups/manual-weighing-labelers.webp"

        },]
    },
    {
        name: "Printers",
        types: [{
            id: "pc-printers",
            label: "PC-Based Printers",
            image: "assets/product-groups/pc-based-printers.webp"

        },]
    },
    {
        name: "Innovations",
        types: [{
            id: "software",
            label: "Software",
            image: "assets/product-groups/software.webp",

        }, {
            id: "esl",
            label: "Digital Signage & ESL",
            image: "assets/product-groups/esl.webp",

        }, {
            id: "all-in-one",
            label: "All In One",
            image: "assets/product-groups/all-in-one.webp",

        },
        ]
    },
    {
        name: "Consumables",
        types: [{
            id: "label",
            label: "Labels",
            image: "assets/product-groups/labels.webp",
        },
        {
            id: "banding-consumables",
            label: "Banding Consumables",
            image: "assets/product-groups/banding-consumables.webp"
        },
        {
            id: "film",
            label: "Film",
            image: "assets/product-groups/film.webp"
        },]
    },
    {
        name: "Food Industry",
        types: [{
            id: "fi-auto-labelers",
            label: "Auto Labelers",
            image: "assets/product-groups/fi-auto-labelers.webp"
        }, {
            id: "fi-manual-labelers",
            label: "Manual Labelers",
            image: "assets/product-groups/fi-manual-labelers.webp"
        }, {
            id: "fi-label-applicators",
            label: "Label Applicators",
            image: "assets/product-groups/fi-label-applicators.webp"
        }, {
            id: "fi-misc",
            label: "Misc.",
            image: "assets/product-groups/product-logo.webp"
        }, {
            id: "fi-wrappers",
            label: "Wrappers",
            image: "assets/product-groups/fi-wrappers.webp"
        }, {
            id: "fi-software",
            label: "Software",
            image: "assets/product-groups/product-logo.webp"
        },
        ],
    },
    {
        name: "Add-On",
        types: [{
            id: "accessories",
            label: "Accessories",
            image: "assets/product-groups/product-logo.webp",

        }, {
            id: "pc-accessories",
            label: "PC-Based Accessories",
            image: "assets/product-groups/pc-based-accessories.webp",

        },
        {
            id: "seal-equipment-accessories",
            label: "Seal Equipment Accessories",
            image: "assets/product-groups/seal-equipment-accessories.webp"
        },]
    },
    {
        name: "Training",
        types: [{
            id: "ai-setup-training",
            label: "AI Setup and Training",
            image: "assets/product-groups/product-logo.webp",

        }, {
            id: "licenses",
            label: "Licenses",
            image: "assets/product-groups/product-logo.webp",
        },
        {
            id: "labor",
            label: "Labor",
            image: "assets/product-groups/product-logo.webp",
        },]
    },
    {
        name: "Other",
        disabled: true,
        types: [{
            id: "custom-solutions",
            label: "Custom Solutions",
            image: "assets/product-groups/all-in-one.webp",
            disabled: true
        },]
    }
];

export const PRODUCT_DEFINITIONS = PRODUCT_TYPE_CATEGORIES.flatMap(item => item.types);